import { FormFieldTypes } from "../../../../../../components/finalForms/libs/data/formFieldType";
import { validationTypes } from "../../../../../../components/finalForms/libs/data/ValidationTypes";
import { GridColumnType } from "../../../../../../components/FinalMolGrid/libs/data/gridColumnType";

const initState = {
  projectModule: '',
}

export const projectmoduelFormData = {
  name: "Project Module Form",
  initialState: initState,
  section: [
    {
      title: "Project Module",
      row: {},
      style: {
        sectionStyle: "col-lg-12 col-md-2",
      },
      wrapperTemplate: <div className="form-card row"></div>,
      fields: [
        {
          id: "projectModule",
          label: "Project Module",
          Field_Name: "project module",
          fieldType: FormFieldTypes.INPUT,
          dataField: "projectModule",
          fieldSetting: {
            placeholder: "Please Enter Project Module",
            allowSpace: true,
            isDisable: false,
          },
          validation: [{type: validationTypes.REQUIRE}],
          style: {
            containerCss: "col-md-12 validation-left-0",
          },
        },
      ]
    }
  ]
}

export const ProjectModuleGridConfig = {
  columns: [
    {
      name: "Project Module",
      fieldName: "projectModule",
      allowShort: false,
    },
    {
      name: "Action",
      colType: GridColumnType.ACTION,
      defaultAction: {
        allowEdit: true,
        allowDelete: true,
      },
    },
  ],
}

export default projectmoduelFormData;